import axiosInstance from "./axios"; // Update the path accordingly
import { useDispatch } from "react-redux";
import { useState } from "react";
import { setSnackbar } from "../Redux/snackBarSlice";

const useDeleteImages = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const deleteItem = async (endpoint, body = {}) => {
    setLoading(true);

    return axiosInstance
      .delete(endpoint, {
        data: body, // Axios expects the body to be included in the `data` field for DELETE requests
      })
      .then((response) => {
        setLoading(false);
        dispatch(
          setSnackbar({
            open: true,
            message: "Deletion successful.",
            error: false,
          })
        );
        return response.data;
      })
      .catch((error) => {
        let errorMsg = "";
        if (error.response?.data?.errorMessage) {
          errorMsg = error.response?.data?.errorMessage;
        } else if (error.response?.data?.error) {
          errorMsg = error.response?.data?.error;
        } else {
          errorMsg = "An unknown error occurred.";
        }
        dispatch(
          setSnackbar({
            open: true,
            message: "Error deleting info: " + errorMsg,
            error: true,
          })
        );
        setLoading(false);
      });
  };

  return { deleteItem, loading };
};

export default useDeleteImages;
